import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Container, Stack } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useNavigate } from "react-router-dom";
import '../../pages/home.css';
import product1 from "../../assets/images/product-1.png";
import product2 from "../../assets/images/product-2.png";
import product3 from "../../assets/images/product-3.png";
import product4 from "../../assets/images/product-4.png";

import Logo from "../../assets/images/logo-uniliver.svg";
import HomeData from "../../assets/homeData"
import { ArrowRightIcon } from "@mui/x-date-pickers";
import logopc from "../../assets/images/logo-pc.png";
import { useAppContext } from "../../hooks/context/AppContext";
import { useLoader } from "../../pages/LoaderContext";
import useSilentIdTokenRefresh from "../../msal/useSilentTokenRefresh";
import useLocalStorage from "../../hooks/useLocalStorage";
import { useApiClient } from "../Services/api/authService";
//Services/api/authService";
import { projectVersion } from "config/navConfig";

const Home: React.FC = () => {
  const { getProfile } = useApiClient()
  localStorage.removeItem("ProjectDetails"); // Clear ProjectDetails from localStorage
  localStorage.removeItem("project_key"); // Clear project_key from localStorage`

  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const [, setUserInfo] = useLocalStorage("user_info", null);
  const [, setAuthData] = useLocalStorage("auth_data", null);
  const { userData, updateUserData, authData, updateAuthData } = useAppContext();
  const [isValidUser, setisValidUser] = useState(true)

  const [idToken, setIdToken] = useState(null);

  const getIdTokenSilently = useSilentIdTokenRefresh((token: any | null, account: any | null) => {
    if (token && account) {
      setIdToken(token);
      const updatedAuthData = {
        ...authData,
        idToken: token,
        name: account.name || authData.name,
        username: account.username || authData.username,
        homeAccountId: account.homeAccountId || authData.homeAccountId,
        environment: account.environment || authData.environment,
        tenantId: account.tenantId || authData.tenantId,
        localAccountId: account.localAccountId || authData.localAccountId,
      };

      updateAuthData(updatedAuthData);
      setAuthData(JSON.stringify(updatedAuthData));
    }
  });

  // Later when you need to get the token manually:
  //const { token, account } = await getIdTokenSilently();



  useEffect(() => {
    if (authData.idToken) {
      setLoading(true)
      fetchUserProfile()
    }
  }, [authData]);



  let fetchUserProfile = async () => {
    let res = await getProfile()
    setLoading(false)
    if (res && res.data) {
      setUserInfo(JSON.stringify(res.data));
      updateUserData(res.data);
    } else {
      setisValidUser(false)
    }
  }


  let handleManageProject = () => {
    // @ts-ignore
    if (userData && userData?.Role) {
      navigate(`${projectVersion}/projects-grid`)
    }
  }
  const chunkArray = (arr: any[], size: number) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };
  const chunkedData = chunkArray(HomeData, 4); // 4 per column
  return (
    <>
      <div className="wrapper bg-full-content">
        <header className="header-wgt-layout">
          <Container sx={{ maxWidth: { xs: "12", md: "100%" } }}>
            <Grid container>
              {/* <Grid size={{ xs: 12 }}>
                <ul className="top-menu-itms">
                  <li className="items-mnv"><span className="link-menu-wtr">Contact for Support</span></li>
                  <li className="items-mnv"><span className="link-menu-wtr"><li className="items-mnv"><span>Glossary</span></li></span></li>
                </ul>
              </Grid> */}
              <Grid container
                columnSpacing={6}
                rowSpacing={2}
                wrap="nowrap"
                sx={{ overflowX: 'auto' }}>
                <Stack
                  direction="row"
                  sx={{ justifyContent: "space-between", alignItems: "flex-end" }}
                >
                  <div style={{ height: "80px" }}></div>
                  <div ><img src={logopc} className="landing-logo" alt="landing-logo"></img></div>
                  <div className="leftside-flex" style={{ display: "flex", alignItems: "center", gap: "1px" }}>
                    <span className="logo-brandImg">
                      {/* <img  alt="iamge"/> */}
                      <span className="dev-tag" style={{ fontSize: "20px", fontWeight: "bold", color: "#ff0000" }}>
                        Developer Version - V1.0.0
                      </span>
                    </span>
                  </div>
                  <div className="right-side-flex">
                    <span className="ul-logo"> <img src={Logo} alt="logo" /></span>
                    {/* @ts-ignore */}
                    <h2 className="start-title-wgt">Welcome, {`${authData.name}  ( ${userData?.Role} ) `} </h2>
                    {/* <p className="short-pl-disc">Description place holder</p> */}

                  </div>

                </Stack>
              </Grid>

            </Grid>
          </Container>
        </header>
        <div className="product-content--area">
          <Container sx={{ maxWidth: { xs: "100%", md: "1360px" } }}>
            <Grid spacing={2} container>
              <Grid size={{ xs: 2, sm: 4, md: 4 }}>
                <div className="product-wap-head">
                  <h2 className="title-analitc">Homecare <br></br>Project Analysis<br></br> Dashboard</h2>
                  <div style={{ display: 'flex', alignItems: 'baseline' }}>
                    <div>
                      {/* <button style={{ cursor: 'pointer' }} onClick={() => handleManageProject()} type="button" className="btn-get-start">Manage Project <b>{'➜'}</b></button> */}

                      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Grid container direction="column" spacing={2}>

                          <Grid>
                            <Box
                              onClick={() => handleManageProject()}
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                backgroundColor: '#F331C3;',
                                borderRadius: '0px',
                                padding: '8px 12px',
                                color: '#fff',
                                cursor: 'pointer',
                                boxShadow: 0,
                                whiteSpace: 'nowrap',
                                minWidth: 220,
                                '&:hover': {
                                  boxShadow: 0,
                                },
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {/* Icon image */}


                                <Typography
                                  fontWeight={600}
                                  color="#fff"
                                // sx={{
                                //   whiteSpace: 'nowrap',
                                //   '&:hover': {
                                //     backgroundColor: '#003d99',
                                //     color: '#fff',
                                //   },
                                // }}
                                >
                                  MANAGE PROJECTS
                                </Typography>
                              </Box>

                              {/* Arrow button */}
                              <Button
                                sx={{
                                  minWidth: '32px',
                                  minHeight: '32px',
                                  backgroundColor: '#0052CC',
                                  color: '#fff',
                                  borderRadius: '4px',
                                  fontWeight: 'bold',
                                  padding: 0,
                                }}
                              >
                                <ArrowRightIcon fontSize="small" />
                              </Button>
                            </Box>

                          </Grid>

                        </Grid>
                      </Grid>


                    </div>
                  </div>
                </div>
              </Grid>
              <Grid size={{ xs: 2, sm: 4, md: 8 }}>
                <Grid spacing={2} container>
                  <Grid size={{ xs: 2, sm: 4, md: 3 }}>
                    <div className="product-wgt-box">
                      <img src={product1} alt="product" />
                    </div>
                  </Grid>
                  <Grid size={{ xs: 2, sm: 4, md: 3 }}>
                    <div className="product-wgt-box">
                      <img src={product2} alt="product" />
                    </div>
                  </Grid>
                  <Grid size={{ xs: 2, sm: 4, md: 3 }}>
                    <div className="product-wgt-box">
                      <img src={product3} alt="product" />
                    </div>
                  </Grid>
                  <Grid size={{ xs: 2, sm: 4, md: 3 }}>
                    <div className="product-wgt-box">
                      <img src={product4} alt="product" />
                    </div>
                  </Grid>

                </Grid>
              </Grid>
            </Grid>
          </Container>
        </div>
        <div className="indside-layout-box">
          <Container sx={{ maxWidth: { xs: "100%", md: "1360px" } }}>
            <Grid>
              <Grid size={{ xs: 12 }}>
                <div className="head-inside-title">
                  <h3 className="title-inside-head">What’s inside</h3>
                </div>
              </Grid>
            </Grid>
            <Grid>
              <Grid container spacing={2} rowSpacing={3} columns={12}>
              
                <Box>
                  <Grid container columnSpacing={2} rowSpacing={2}>

                    {chunkedData.map((column, colIndex) => (
                      <Grid size={{ xs: 12, sm: 6, md: 3 }} key={colIndex}>
                        <Grid container direction="column" spacing={2}>
                          {column.map((item, index) => (
                            <Grid key={index}>
                              <a href={item.link || '#'} target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none' }} > 
                              <Box className='landingTiles'
                                // onClick={() => window.open(item.link || '#', '_blank')}
                                onClick={() => window.location.href = item.link || '#'}

                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  {/* Icon image */}
                                  <img src={item.icons} alt={item.name} style={{ width: 28, height: 28 }} />
                                  <Typography
                                    fontWeight={600}
                                    color="#0052CC"
                                  // sx={{
                                  //   whiteSpace: 'nowrap',
                                  //   '&:hover': {
                                  //     backgroundColor: '#003d99',
                                  //     color: '#fff',
                                  //   },
                                  // }}
                                  >
                                    {item.name}
                                  </Typography>
                                </Box>

                                {/* Arrow button */}
                                <Button
                                  sx={{
                                    minWidth: '32px',
                                    minHeight: '32px',
                                    backgroundColor: 'transparent',
                                    color: '#0052CC',
                                    borderRadius: '4px',
                                    fontWeight: 'bold',
                                    padding: 0,
                                  }}
                                >
                                  <ArrowRightIcon fontSize="small" />
                                </Button>
                              </Box>
                              </a>
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
                
              </Grid>
            </Grid>
          </Container>
        </div>
      </div>
      {/* @ts-ignore */}
      {/* <AuthModal open={!isValidUser}  /> */}
    </>
  );
};

export default Home;
